module.exports = __webpack_public_path__ + "img/dep_menu.07f2657b.png";